module.exports = {
    DEAL_POSSIBLE : "Deal possible",
    DEAL_POSSIBLE_REMPLI : "Deal possible rempli",
    DEVIS : "Devis",
    DEVIS_DEVIS_VALIDE : "Devis / Devis validé",
    DEVIS_VALIDE :"Devis validé",
    EN_ATTENTE_DE_RESILIATION : "En attente de résiliation",
    EN_ATTENTE_DE_FORMALITE_MEDICALE : "En attente de formalité médicale",
    CONTRAT_ENVOYE :"Contrat envoyé",
    CONTRAT_CLOTURE : "Contrat clôturé",
    EN_ATTENTE_BANQUE : "En attente de la banque",
    CONTRAT_ENVOYE_CLOTURE : "Contrat envoyé / clôturé",
    CONTRAT_CLO_ATT : "Contrat clôturé / attente banque",
    CONTRAT_ENV_ATT_CLO : "Contrat envoyé / attente banque / clôturé",
    PERDU_ARCHIVE : "Perdu / archivé",
    ARCHIVE : "Archivé"
}
